import PropTypes from "prop-types"
import React, { useState } from "react"
import { connect, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "../Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { appConstants } from "../../constants/app_constants"
import { headerArrowLeft } from "../Common/SvgIcons"
import { sidebarSizeTypes } from "../../constants/layout"
import { changeSidebarSize } from "../../store/actions"

let logoDark = appConstants.logoDark
let logoLight = appConstants.logoLight
let logoSm = appConstants.logoSm

const Sidebar = props => {
  const dispatch = useDispatch()
  const [hoverMenu, setHoverMenu] = useState(false)

  function tToggle() {
    var body = document.body
    var windowSize = document.documentElement.clientWidth

    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")

    if (windowSize > 991) {
      let x = ""
      if (body.getAttribute("data-sidebar-size") === "sm") {
        x = sidebarSizeTypes.DEFAULT
      } else {
        x = sidebarSizeTypes.ICON
      }
      body.setAttribute("data-sidebar-size", x)
      dispatch(changeSidebarSize(x))
      localStorage.setItem("SiderBarType", x)
    }
  }

  // useEffect(() => {
  //   // var verticalOverlay = document.getElementsByClassName("vertical-overlay");
  //   if (document.body.classList.contains("vertical-collpsed") && document.body.classList.contains("sidebar-enable")) {
  //     // verticalOverlay[0].addEventListener("click", function () {
  //       document.body.classList.remove("vertical-collpsed");
  //       document.body.classList.remove("sidebar-enable");

  //     };
  //   // }
  // });

  const hideHoverMenu = () => {
    var body = document.body
    if (body.getAttribute("data-sidebar-hover") === "true") {
      setHoverMenu(false)
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu" onMouseLeave={hideHoverMenu}>
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="24" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="24" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="24" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="24" />
            </span>
          </Link>
        </div>
        <button
          onClick={() => {
            tToggle()
          }}
          type="button"
          className="btn btn-sm font-size-16 header-item waves-effect vertical-menu-btn"
        >
          {headerArrowLeft}
        </button>
        <div className="sidebar-menu-scroll">
          <SidebarContent hoverMenu={hoverMenu} setHoverMenu={setHoverMenu} />
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
